import trans from "../trans";
import { Language } from "../types/locale";
import { useFeatureServices } from "../use-feature-services";

const useTrans = (lang?: Language) => {
    const { 'locale-service': localeService } = useFeatureServices();

    if (lang) {
        return trans(lang);
    }

    return trans(localeService.language as unknown as Language);
}

export default useTrans;
